











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";
import appConfig from "@/config";
import {formatNumberWithGrouping} from "@/data/sources/numbers";


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Doughnut2D(),
      widget: "FloorArea",
      title: "Lord Carter KPIs",
      _description: "Lord Carter KPIs",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      fusionChartParams: {
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: 'Floor area, Sq.m',
        // rotatelabels: '1',
        // setadaptiveymin: '1',
        // labelDisplay: '$label , $value',
        // showLabels: '1',
        showValues: '1',
        showPercentageValues: "1",
        // legendCaption: 'Rooms',
        defaultCenterLabel: "",
        // centerLabel: "Area: $value",
      // showPercentInTooltip: "0",
      bgColor: "#FFFFFF",
      // showLegend: "1",
      },
    )
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      let sharedChartDataConfig

      async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
        if (config) {
          sharedChartDataConfig = chartDataConfig
          chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
        }
      }

      async function dataFetcher(params: any): Promise<{ data: any[] }> {
        const data = await executeQuery(
            "idr",
            "eric.floorArea", {
              locationId: parseInt(params.locationId.value),
              cpId: 1693 /* todo */
            });
        // [{"cp_value":"Unassigned Area","roomarea":503690.2200,"roomcount":28139}]
        // console.debug("FloorArea:", data)
        if (sharedChartDataConfig)
          sharedChartDataConfig.defaultCenterLabel = "Total:{br}" + formatNumberWithGrouping(data.reduce((sum, item) => sum + item.roomarea, 0)) + "{br}Sq.m"
        const palette: Map<string, string> = new Map<string, string>([
            ["Non-Clinical Space", "#6DA2CC"],
            ["Clinical Space", "#6DCC77"],
            ["Unassigned Area", "#FF0000"],
        ])
        return {
          data: data.map(item => {
            return {
              label: item.cp_value,
              value: item.roomarea,
              toolText: item.cp_value + " - " + formatNumberWithGrouping(item.roomarea) + " Sq.m",
              color: palette.get(item.cp_value) || undefined,
            }
          }),
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        const iprUrl = appConfig.IPR_BASE_URL
        const locationId = props.config.params.locationId.value
        window.open(iprUrl + `/pages/eric_site.asp?id=${locationId}&return=site_details.aspx?id=${locationId}`)
        console.log("chartClickCallback", label, val)
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
